export default __webpack_public_path__ + "static/media/handwash.e1e41ecc.png";